<div
  class="grid-wrapper"
  [ngClass]="{
    'hide-paginator-space': sortedData.data?.length <= defaultPageSize && !resultVisible
  }"
  matSort
>
  <nrwl-no-data
    *ngIf="sortedData.data?.length === 0"
    [detailMessage]="noDataFoundMsg"
  ></nrwl-no-data>

  <ng-container *ngIf="sortedData.data?.length > 0">
    <div [ngClass]="options?.classes">
      <mat-table class="data-list hide-Scroll" [dataSource]="sortedData">
        <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select" *ngIf="!hideActionsColumn">
          <mat-header-cell
            *matHeaderCellDef
            arrowPosition="{{
              options.headerSortArrowPosition ? options.headerSortArrowPosition : 'after'
            }}"
            mat-sort-header
            disabled="true"
            class="small-column"
          >
            <div class="checkbox-cell">
              <mat-checkbox
                color="primary"
                (change)="masterToggle()"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                [disabled]="isCheckboxColumnDisabled()"
                [class.disabled]="isCheckboxColumnDisabled()"
              >
              </mat-checkbox>
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="$event.stopPropagation()" class="small-column">
            <div class="checkbox-cell">
              <mat-checkbox
                color="primary"
                (change)="onChange(row)"
                [checked]="isChecked(row)"
                aria-label="Select"
                [disabled]="row?.isDisabled ? row.isDisabled : false"
                [class.disabled]="row?.isDisabled ? row.isDisabled : false"
              >
              </mat-checkbox>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container *ngFor="let header of columns" matColumnDef="{{ header.id }}">
          <mat-header-cell
            *matHeaderCellDef
            arrowPosition="{{
              options.headerSortArrowPosition ? options.headerSortArrowPosition : 'after'
            }}"
            mat-sort-header
            [disabled]="header.disableSorting || isSortingDisabled()"
            [ngClass]="{
              'small-column': header.type === 'vertical-bar',
              'medium-column':
                header.type === 'icon-text-column' ||
                header.type === 'actions' ||
                header.type === 'med-text'
            }"
          >
            <span [innerHTML]="header.title" class="title"></span>
            <div class="header_subtext" *ngIf="header.sub_text">{{ header.sub_text }}</div>
          </mat-header-cell>

          <mat-cell
            [ngSwitch]="header.type"
            mat-cell
            *matCellDef="let element"
            (click)="itemMenu && menuTrigger.openMenu()"
            [ngClass]="{
              highlightCol: 'highlightCol' === header.class,
              'small-column': header.type === 'vertical-bar',
              'medium-column':
                header.type === 'icon-text-column' ||
                header.type === 'actions' ||
                header.type === 'med-text'
            }"
          >
            <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></div>
            <mat-menu #menu="matMenu" xPosition="after">
              <div *ngIf="!!element[header.id]">
                <ng-container
                  *ngTemplateOutlet="itemMenu; context: { id: header.id, item: element }"
                ></ng-container>
              </div>
              <button mat-menu-item *ngIf="!element[header.id]">It is not available</button>
            </mat-menu>

            <div class="checkbox-cell" *ngSwitchCase="'select-box'">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(element) : null"
                [checked]="selection.isSelected(element)"
                aria-label="Select"
              >
              </mat-checkbox>
            </div>

            <div class="text truncated-text" *ngSwitchCase="'text-disabled'">
              <span matTooltip="{{ element[header.id] }}">{{ element[header.id] }}</span>
              <span *ngIf="element?.isDeleted" class="state-label bg-gray">DELETED</span>
            </div>

            <div class="text truncated-text" *ngSwitchCase="'text'">
              <div *ngIf="header.id !== 'threatSourceCountry'">
                <div class="truncated-text" matTooltip="{{ element[header.id] }}">
                  {{ element[header.id] }}
                </div>
                <div
                  class="troubleshooting"
                  *ngIf="element.runType?.sublabeltext === 'On demand' && header.id === 'alias'"
                >
                  <span>{{ element.runType.sublabeltext }}</span>
                </div>
                <div *ngIf="header.id === 'monitors' && element.port2">
                  {{ element.monitorsP2 }}
                </div>
              </div>
              <!-- Threat Source Location Column -->
              <div *ngIf="header.id === 'threatSourceCountry'">
                <div *ngIf="element['targetSite'] === 'Public' || element['targetSite'] === '-'">
                  {{ element[header.id] }}
                </div>
                <div *ngIf="element['targetSite'] !== 'Public' && element['targetSite'] !== '-'">
                  <div class="table-two-column-1-row">
                    <div class="first">
                      <mat-icon class="mdi mdi-city-variant-outline loc-icon"></mat-icon>
                    </div>
                    <div class="second two-rows">
                      <div class="subtitle">Site</div>
                      {{ element['targetSite'] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="text truncated-text" *ngSwitchCase="'med-text'">
              <div>{{ element[header.id] }}</div>
            </div>

            <div class="text" *ngSwitchCase="'array-text'">
              <div *ngFor="let item of element[header.id]">{{ item }}</div>
            </div>

            <div class="icon-text truncated-text" *ngSwitchCase="'icon-text'">
              <div class="icon-wrapper">
                <logo-widget
                  *ngIf="element[header.id].icon"
                  [serviceUrl]="element[header.id].url"
                  [defaultUrl]="element[header.id].icon"
                  [styleInfo]="'table'"
                ></logo-widget>
              </div>
              <div class="icon-text-wrapper">
                <div class="main-title" [matTooltip]="element[header.id].label">
                  {{ element[header.id].label }}
                </div>
                <div
                  *ngIf="element[header.id].sublabel"
                  class="sub-title truncated-text"
                  [matTooltip]="element[header.id].sublabel"
                >
                  {{ element[header.id].sublabel }}
                </div>
              </div>
            </div>
            <div class="icon-text" *ngSwitchCase="'label-sublabel'">
              <div class="icon-text-wrapper">
                <div class="main-title">
                  {{ element[header.id].label }}
                </div>
                <div
                  *ngIf="element[header.id].sublabel"
                  class="sub-title truncated-text"
                  [matTooltip]="element[header.id].sublabel"
                >
                  {{ element[header.id].sublabel }}
                </div>
              </div>
            </div>
            <div class="icon-text" *ngSwitchCase="'text-with-highlight'">
              <div class="icon-text-wrapper">
                <div [ngClass]="{ highlighted: element[header.id]?.highlighted }">
                  <div
                    *ngIf="header.id !== 'bytes'"
                    (click)="send(element, header)"
                    class="main-title"
                  >
                    {{ element[header.id].label }}
                  </div>
                  <div *ngIf="header.id == 'bytes'">{{ element[header.id].label | byte }}</div>
                </div>
              </div>
            </div>

            <div class="text" *ngSwitchCase="'text-icon-label'">
              <div class="truncated-text">
                {{ element[header.id].label }}
                <div class="icon-wrapper">
                  <div
                    class="upgrade"
                    matTooltip="{{ element[header.id].upgradeInfo }}"
                    [ngClass]="element[header.id].upgradeClass"
                    *ngIf="element[header.id].upgradeStatus"
                  >
                    <mat-icon [inline]="true" class="icon">
                      {{ element[header.id].matIcon }}
                    </mat-icon>
                    {{ element[header.id].upgradeStatus }}
                  </div>
                </div>
              </div>
            </div>

            <div class="t-btn icon-text-column" *ngSwitchCase="'icon-text-column'">
              <div class="icon-wrapper">
                <logo-widget
                  *ngIf="element[header.id].icon"
                  [serviceUrl]="element[header.id].url"
                  [defaultUrl]="element[header.id].icon"
                  [styleInfo]="'icon'"
                  [iconClass]="element[header.id].iconclass"
                  [imgType]="element[header.id].imgType"
                ></logo-widget>
              </div>
              <div class="icon-text-wrapper">
                <div class="main-title">
                  {{ element[header.id].label }}
                </div>
                <div *ngIf="element[header.id].sublabel" class="sub-title">
                  {{ element[header.id].sublabel }}
                </div>
              </div>
            </div>

            <div class="bar-tick" *ngSwitchCase="'vertical-bar'">
              <div
                [ngStyle]="{ background: element[header.id].color }"
                [ngClass]="element[header.id].class"
              >
                I
              </div>
            </div>

            <div class="tick" *ngSwitchCase="'mat-icon'">
              <mat-icon
                [ngStyle]="{ color: element[header.id].color }"
                [ngClass]="element[header.id].class"
              >
                {{ element[header.id].icon }}</mat-icon
              >
            </div>

            <div class="tick" *ngSwitchCase="'mat-action-icon'" (click)="$event.stopPropagation()">
              <mat-icon
                [ngStyle]="{ color: element[header.id].color }"
                [ngClass]="element[header.id].class"
                (click)="onActionClick(element.id)"
              >
                {{ element[header.id].icon }}</mat-icon
              >
            </div>

            <div class="icon-text" *ngSwitchCase="'badge'">
              <div class="icon-wrapper">
                <div class="badge" [ngClass]="element[header.id]"></div>
              </div>

              <div class="icon-text-wrapper">
                <div class="main-title">
                  {{ element[header.id] }}
                </div>
              </div>
            </div>

            <div class="badge-text" *ngSwitchCase="'badge-text'">
              <div class="icon-wrapper">
                <div class="badge" [ngClass]="element[header.id].class"></div>
              </div>
              <div class="icon-text-wrapper">
                <div class="main-title">
                  {{ element[header.id].value }}
                </div>
              </div>
            </div>

            <div
              *ngSwitchCase="'label'"
              class="label truncated-text"
              [matTooltip]="element[header.id].labelMessage || element[header.id].name"
            >
              <div
                *ngFor="let elem of element[header.id]; let last = last"
                [ngClass]="elem.result"
                [matTooltip]="elem.label.toLowerCase() !== 'running' ? elem.labelMessage : ''"
              >
                {{ elem.label || elem.name }}{{ last ? '' : ',&nbsp;' }}
              </div>
              <div class="icons" *ngIf="element[header.id][0]?.icons">
                <i
                  ng-class="{ uncheck: !element.scheduledTime }"
                  class="material-icons status-icon"
                  >{{ element[header.id][0].icons[1] }}</i
                >
                <i
                  ng-class="{ uncheck: !element.precheckEnabled }"
                  class="material-icons status-icon"
                  >{{ element[header.id][0].icons[0] }}</i
                >
              </div>
            </div>
            <div class="text truncated-text" *ngSwitchCase="'date-time'">
              <div
                class="truncated-text"
                matTooltip="{{ formatDateTime(element[header.id], dtFormatUTC) }}"
              >
                {{ formatDateTime(element[header.id], dtFormatLocal) }}
              </div>
            </div>
            <div class="text truncated-text" *ngSwitchCase="'date-time-second'">
              <div
                class="truncated-text"
                matTooltip="{{ formatDateTime(element[header.id], dtFormatUTCWithSeconds) }}"
              >
                {{ formatDateTime(element[header.id], dtFormatLocalWithSeconds) }}
              </div>
            </div>
            <div class="text truncated-text" *ngSwitchCase="'kpi-text'">
              <div
                class="truncated-text"
                matTooltip="{{ formatKpiValue(element[header.id], element['KPIName']) }}"
              >
                {{ formatKpiValue(element[header.id], element['KPIName']) }}
              </div>
            </div>
            <div *ngSwitchCase="'badge-score'">
              <div class="badge-score" [ngClass]="element[header.id].class">
                {{ element[header.id].value }}
              </div>
            </div>

            <div
              class="duration"
              *ngSwitchCase="'duration'"
              [innerHTML]="
                element[header.id] | formatValueWithUnit: UNIT.nanoseconds | domSanitizer: 'html'
              "
            ></div>

            <div
              class="status-icon"
              *ngSwitchCase="'status-icon'"
              [matTooltip]="element[header.id].labelMessage"
              [matTooltipPosition]="'right'"
              matTooltipClass="mat-pre-line"
            >
              <div [ngClass]="element[header.id].result">{{ element[header.id].label }}</div>
              <div class="icons truncated-text" *ngIf="element[header.id].icons">
                <i
                  class="material-icons status-icon"
                  [ngClass]="{ 'pc-inactive': !element.scheduledTime }"
                  >{{ element[header.id].icons[0] }}</i
                >
                <i class="material-icons status-icon" [ngClass]="'pc-' + element.precheckStatus">{{
                  element[header.id].icons[1]
                }}</i>
              </div>
            </div>
            <div *ngSwitchCase="'status_icon'">
              <div class="status_icon">
                <i [ngClass]="element?.icon" class="icon"></i>
                <div [ngClass]="element[header.id]" class="statu-name">
                  {{ element[header.id] }}
                </div>
              </div>
              <div *ngIf="element[header.id] == 'failed'" class="error">
                {{ element.errorMessage }}
              </div>
            </div>
            <div *ngSwitchCase="'icon-expand'" class="icon-expand">
              <div class="icon-expand-container">
                <div
                  class="truncated-text originator"
                  title="{{ element[header.id].originator.label }}"
                >
                  {{ element[header.id].originator.label }}
                </div>
                <div>
                  <div class="svg-container" [ngClass]="{ 'set-height': element.isExpand }">
                    <div
                      class="svg"
                      [innerHTML]="getSingleSvgContent(element.singleEndpointSvg)"
                    ></div>
                    <div class="icon-container">
                      <i
                        class="mdi mdi-arrow-down-drop-circle-outline expand-icon"
                        *ngIf="!isExpand(element) && element?.endpoints?.length > 1"
                        (click)="$event.stopPropagation(); expandRow(element)"
                      ></i>

                      <i
                        class="mdi mdi-arrow-up-drop-circle-outline expand-icon"
                        *ngIf="isExpand(element) && element?.endpoints?.length > 1"
                        (click)="$event.stopPropagation(); expandRow(element)"
                      ></i>
                      <div
                        class="truncated-text destination"
                        title="{{ element[header.id].destination.label }}"
                      >
                        <span *ngIf="element?.endpoints?.length == 1">
                          {{ element[header.id].destination.label }}</span
                        >
                        <span class="total-endpoints" *ngIf="element?.endpoints?.length > 1">
                          {{ element?.endpoints?.length }} Endpoints</span
                        >
                      </div>
                    </div>
                  </div>

                  <div
                    class="endpoint-svg"
                    [innerHTML]="getSvgContent(element.svg)"
                    *ngIf="isExpand(element) && element?.endpoints?.length > 1"
                  ></div>
                </div>
              </div>
            </div>

            <div
              class="status-icon-label"
              *ngSwitchCase="'status-icon-label'"
              [matTooltip]="element[header.id].labelMessage"
              [matTooltipPosition]="'right'"
              matTooltipClass="mat-pre-line"
            >
              <div [ngClass]="element[header.id].result">{{ element[header.id].label }}</div>
              <div class="icons truncated-text" *ngIf="element[header.id].icons">
                <i
                  class="material-icons status-icon-label"
                  [ngClass]="{ 'pc-inactive': !element.scheduledTime }"
                  >{{ element[header.id].icons[0] }}</i
                >
                <i
                  class="material-icons status-icon-label"
                  [ngClass]="'pc-' + element.precheckStatus"
                  >{{ element[header.id].icons[1] }}</i
                >
              </div>
            </div>
            <div class="progress" *ngSwitchCase="'progress'">
              <div *ngIf="element[header.id]">
                <div class="progress-text-wrapper">
                  <div class="title">
                    {{ element[header.id].text }}
                  </div>
                </div>
                <div class="progress-wrapper">
                  <div
                    class="progress-bar"
                    [ngClass]="{ wide: element[header.id].text }"
                    *ngIf="element[header.id].text && element[header.id].status_f"
                    [matTooltip]="element[header.id].toolTip"
                    [matTooltipPosition]="'right'"
                    matTooltipClass="mat-pre-line"
                  >
                    <div
                      *ngIf="element[header.id].level_q"
                      class="progress-width"
                      [ngStyle]="{ width: element[header.id].level_q + '%' }"
                      [ngClass]="element[header.id].status_q"
                    ></div>
                    <div
                      *ngIf="element[header.id].level_f"
                      class="progress-width"
                      [ngStyle]="{ width: element[header.id].level_f + '%' }"
                      [ngClass]="element[header.id].status_f"
                    ></div>
                    <div
                      class="progress-width"
                      [ngStyle]="{ width: element[header.id].level_r + '%' }"
                      [ngClass]="element[header.id].status_r"
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="actions" *ngSwitchCase="'actions'" (click)="$event.stopPropagation()">
              <button
                [matMenuTriggerFor]="menu"
                mat-button
                class="btn-menu-trigger actions-btn"
                aria-label="Action menu"
              >
                <i class="material-icons">more_horiz</i>
              </button>
              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  class="t-btn"
                  *ngFor="let list of element[header.id]"
                  [disabled]="list.disable"
                  (click)="onActionClick(element.id, list.option, element.rowId)"
                >
                  <i class="t-icon icon mdi" [ngClass]="list.iconName"></i>
                  {{ list.option }}
                </button>
              </mat-menu>
            </div>
            <div class="actions" *ngSwitchCase="'action-icon'" (click)="$event.stopPropagation()">
              <button
                [disabled]="disableDoAction(element)"
                [matMenuTriggerFor]="menu"
                mat-button
                class="btn-menu-trigger"
                aria-label="Action menu"
              >
                <i class="material-icons">more_horiz</i>
              </button>
              <mat-menu #menu="matMenu">
                <div *ngFor="let list of element[header.id]">
                  <button
                    mat-menu-item
                    [disabled]="list.disable"
                    (click)="onActionClick(element.id, list.option, element.rowId)"
                    class="flex"
                  >
                    <span [ngClass]="list.class" class="list-icon"></span>
                    {{ list.option }}
                  </button>
                  <div *ngIf="list.subText" class="sub-text">
                    {{ list.subText }}
                  </div>
                </div>
              </mat-menu>
            </div>

            <div class="actions" *ngSwitchCase="'action-btn'" (click)="$event.stopPropagation()">
              <button class="btn action-btn" (click)="onActionClick(element.id, 'viewNrt')">
                {{ header.buttonTitle }}
              </button>
            </div>

            <div class="text truncated-text" *ngSwitchCase="'date'">
              {{ formatDate(element[header.id]) }}
              <div class="time">{{ formatTime(element[header.id]) }}</div>
            </div>

            <div class="text" *ngSwitchCase="'alias'">
              <div class="truncated-text" title="{{ element[header.id].alias }}">
                {{ element[header.id].alias }}
              </div>
              <div class="troubleshooting" *ngIf="element[header.id].runType">
                {{ element[header.id].runType }}
              </div>
            </div>

            <div class="icon-text" *ngSwitchCase="'state-text'">
              <state-preview></state-preview>
              <div class="state-label">
                <div [ngClass]="element[header.id]">
                  {{ element[header.id].toUpperCase() }}
                </div>
              </div>
              <div class="icon-text-wrapper" *ngIf="element[header.id].float !== 'left'">
                <div class="main-title">
                  {{ element[header.id].label }}
                </div>
              </div>
            </div>

            <div
              class="status-preview"
              *ngSwitchCase="'status-preview'"
              matTooltip="{{
                getArrayString(element[header.id], 'labelMessage') ||
                  getArrayString(element[header.id], 'name')
              }}"
              [matTooltipPosition]="'right'"
            >
              <state-preview></state-preview>
              <logo-widget
                *ngIf="element[header.id].icon"
                [serviceUrl]="element[header.id].url"
                [defaultUrl]="element[header.id].icon"
                [styleInfo]="'table'"
              ></logo-widget>
            </div>

            <div class="text truncated-text" *ngSwitchCase="'name_sub_label'">
              <div class="truncate">{{ element[header.id].alias }}</div>
              <div class="alias-sublabel" *ngIf="element[header.id].subLabel">
                {{ element[header.id].subLabel }}
              </div>
              <div class="alias-sublabel" *ngIf="element[header.id].port2">
                {{ element[header.id].port2 }}
              </div>
            </div>

            <div class="icon-sublabel" *ngSwitchCase="'icon-sublabel'">
              <div class="icon-text-wrapper" *ngIf="element[header.id].float === 'left'">
                <div class="main-title truncate-icon-text right">
                  {{ element[header.id].label }}
                </div>
                <div class="sub-label right">
                  {{ element[header.id].subLabel }}
                </div>
              </div>
              <div class="icon-wrapper">
                <logo-widget
                  *ngIf="element[header.id].icon"
                  [serviceUrl]="element[header.id].url"
                  [defaultUrl]="element[header.id].icon"
                  [styleInfo]="'table'"
                ></logo-widget>
              </div>
              <div class="icon-text-wrapper" *ngIf="element[header.id].float !== 'left'">
                <div class="main-title truncate-icon-text left">
                  {{ element[header.id].label }}
                </div>
                <div class="sub-label left">
                  {{ element[header.id].subLabel }}
                </div>
              </div>
            </div>

            <div class="text truncated-text text-link" *ngSwitchCase="'text-link'">
              <div title="{{ element[header.id] }}">{{ element[header.id] }}</div>
            </div>

            <div class="text truncated-text" *ngSwitchCase="'text-units'">
              {{ element[header.id].value }} {{ element[header.id].unit }}
            </div>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumnsIds"></mat-header-row>
        <mat-row
          *matRowDef="let row; let i = index; columns: displayedColumnsIds"
          [ngClass]="{
            hovered: row.hovered,
            highlighted: currentRowId === row.id
          }"
          class="{{ row.highlightClass }}"
          (click)="selectItemBasedOnIndex(row.id, { event: $event })"
          (mouseover)="onRowHover(row, 'over', $event, i); row.hovered = true"
          (mouseout)="onRowHover(row, 'out'); row.hovered = false"
        ></mat-row>
      </mat-table>
    </div>
  </ng-container>
  <nrwl-paginator
    #paginator
    [totalResult]="sortedData.data?.length"
    [totalCount]="count"
    [defaultPageSize]="defaultPageSize"
    [hidePageSizer]="hidePageSizer"
    [totalResVisible]="resultVisible"
    (nextPage)="nextPage($event)"
  ></nrwl-paginator>
</div>
